import React from "react";
import { CreditCard, Store, Users, Package, ShoppingCart, Check, Lock } from "lucide-react";
import type { StepDefinition } from "../../../slices/onboardingSlice";

const ICON_MAP: Record<string, React.FC<{ className?: string }>> = {
  plan_selection: CreditCard,
  store_setup: Store,
  employees: Users,
  inventory: Package,
  sales: ShoppingCart,
  customers: Users,
};

interface Props {
  steps: StepDefinition[];
  currentStep: number;
  completedSteps: boolean[];
}

const OnboardingStepper: React.FC<Props> = ({ steps, currentStep, completedSteps }) => {
  return (
    <div className="w-full py-4">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const isCompleted = completedSteps[index];
          const isCurrent = index === currentStep;
          const isLocked = index > currentStep && !isCompleted;
          const Icon = ICON_MAP[step.key] ?? Package;

          return (
            <React.Fragment key={step.key}>
              {/* Step circle */}
              <div className="flex flex-col items-center gap-1">
                <div
                  className={`flex h-10 w-10 items-center justify-center rounded-full border-2 transition-colors ${
                    isCompleted
                      ? "border-primary bg-primary text-white"
                      : isCurrent
                      ? "border-primary bg-white text-primary"
                      : "border-gray-300 bg-gray-100 text-gray-400"
                  }`}
                >
                  {isCompleted ? (
                    <Check className="h-5 w-5" />
                  ) : isLocked ? (
                    <Lock className="h-4 w-4" />
                  ) : (
                    <Icon className="h-5 w-5" />
                  )}
                </div>
                <span
                  className={`text-xs font-medium ${
                    isCompleted || isCurrent ? "text-primary" : "text-gray-400"
                  }`}
                >
                  {step.label}
                </span>
              </div>

              {/* Connector line */}
              {index < steps.length - 1 && (
                <div
                  className={`mx-1 h-0.5 flex-1 ${
                    completedSteps[index] ? "bg-primary" : "bg-gray-300"
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default OnboardingStepper;
